class PseudolinkLoader extends HTMLElement {
  connectedCallback () {
    this.url = this.getAttribute('url')
    this.method = this.getAttribute('method') || 'get'
    this.targetsSelector = this.getAttribute('target')
    this.targets = document.querySelectorAll(this.targetsSelector)

    this.onclick = this._doFetch

    this.shots = 'infinite'
    if (this.hasAttribute('shots')) {
      let shots = parseInt(this.getAttribute('shots'))
      this.removeAttribute('shots')
      this.shots = isNaN(shots) ? this.shots : shots
    }

    if (this.hasAttribute('autoclick')) {
      fetch(this.url, this._fetchOptions())
        .then((response) => this._textoSiEsCorrecta(response))
        .then((html) => {
          if (html !== null) this._updateTarget(html)
        })

        if (this.targets.length === 1) {
          this.scrollIntoView()
        }
    }
  }

  static get observedAttributes () {
    return ['url']
  }

  attributeChangedCallback (attrName, oldVal, newVal) {
    if (attrName === 'url') {
      this.url = newVal
    }
  }

  _doFetch () {
    // No hacer nada si está deshabilitado (ej: autor votando su propio contenido)
    if (this.hasAttribute('disabled')) {
      const mensaje = this.getAttribute('title') || 'Acción no permitida'
      alert(mensaje)
      return
    }

    if (this.canFire && !this.classList.contains('pseudolink-loader--loading')) {
      this.classList.add('pseudolink-loader--loading')
      fetch(this.url, this._fetchOptions())
        .then((response) => this._textoSiEsCorrecta(response))
        .then((responseText) => {
          if (responseText === null) {
            this.classList.remove('pseudolink-loader--loading')
            return
          }

          // Intentar parsear como JSON para manejar múltiples componentes
          try {
            const jsonResponse = JSON.parse(responseText)
            if (jsonResponse.voto_html || jsonResponse.dislike_html) {
              this._updateMultipleComponents(jsonResponse)
            } else {
              this._updateTarget(responseText)
            }
          } catch (e) {
            // Si no es JSON, manejar como HTML normal
            this._updateTarget(responseText)
          }
          this.classList.remove('pseudolink-loader--loading')
          this._burnOne()
        })
    }
  }

  // Una respuesta de error (422 sin token CSRF válido, 403, 404…) no trae el HTML que sustituye
  // al botón: pintarla lo vaciaba o, con `mode: 'replace-children'`, lanzaba un TypeError antes de
  // quitar el spinner y el botón se quedaba girando. Con `null` no se pinta nada y se puede repetir.
  _textoSiEsCorrecta (response) {
    return response.ok ? response.text() : null
  }

  // Lo que no es GET lleva el token CSRF de la página, como un formulario de Rails: sin él, los
  // controladores que lo exigen (SuscripcionesEnUnClickController) responden 422.
  _fetchOptions () {
    const options = { method: this.method, credentials: 'same-origin' }
    if (this.method.toLowerCase() === 'get') return options

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) options.headers = { 'X-CSRF-Token': token }
    return options
  }

  _updateTarget (html) {
    if (this.getAttribute('mode') === 'replace-pseudolink') {
      this._replaceTargetsPseudolinks(html)
    } else if (this.getAttribute('mode') === 'replace-children') {
      this._replaceTargetsChildren(html)
    } else { // default, could be named as 'replace-inner'
      this._replaceTargetsInner(html)
    }
  }

  _updateMultipleComponents (jsonResponse) {
    const contenidoId = jsonResponse.contenido_id

    // Actualizar componente de voto si está presente
    if (jsonResponse.voto_html) {
      const votoTarget = document.querySelector(`.voto_${contenidoId}`)
      if (votoTarget) {
        votoTarget.outerHTML = jsonResponse.voto_html
      }
    }

    // Actualizar componente de dislike si está presente
    if (jsonResponse.dislike_html) {
      const dislikeTarget = document.querySelector(`.dislike_${contenidoId}`)
      if (dislikeTarget) {
        dislikeTarget.outerHTML = jsonResponse.dislike_html
      }
    }
  }

  _replaceTargetsPseudolinks (html) {
    const matchSelector = `${this.targetsSelector} pseudolink-loader`
    const oldPseudolinks = document.querySelectorAll(matchSelector)
    const newPseudolink = new DOMParser().parseFromString(html, 'text/html')
                          .body.querySelector(matchSelector)

    if (newPseudolink) oldPseudolinks.forEach(old => {
      old.replaceWith(newPseudolink.cloneNode(true))
    })
  }

  _replaceTargetsChildren (html) {
    const newNodes = new DOMParser().parseFromString(html, 'text/html')
                          .body.querySelector('*').children

    if (newNodes) this.targets.forEach(target => {
      target.replaceChildren(...newNodes)
    })
  }

  _replaceTargetsInner (html) {
    this.targets.forEach(target => target.innerHTML = html)
  }

  _burnOne () {
    if (!this.infiniteCartriges) {
      --this.shots
    }
  }

  get infiniteCartriges () {
    return this.shots === 'infinite'
  }

  get canFire () {
    return this.infiniteCartriges || this.shots > 0
  }
}

export default PseudolinkLoader
